import React, { useState, useEffect } from 'react';
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  MenuItem,
  FormControlLabel,
  IconButton,
  Switch,
  Menu,
} from '@material-ui/core';
import { toJS } from 'mobx';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DeleteIcon from '@material-ui/icons/Delete';
import CirclePlusIcon from '@material-ui/icons/AddCircleOutline';
import { useRootStore } from '../../stores/BridgeProvider';
import Spinner from '../util/Spinner';
import {
  getWidgetFromShortName,
  getViableWidgets,
  getSizeFromLength,
} from './dashUtil';
import SimpleSelect from '../util/SimpleSelect';
import RenderPropModal from '../dealMapper/common/RenderPropModal';

const DashboardPref = () => {
  const { orgStore, authStore } = useRootStore();
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const [preferences, setPreferences] = useState([
    [
      { Name: 'totalDealsGross' },
      { Name: 'completeDealsGross' },
      { Name: 'unmappedDealsGross' },
      { Name: 'atRiskDealsGross' },
    ],
    [{ Name: 'syncStatus' }, { Name: 'topAgents' }],
    [{ Name: 'unpaidVouchers' }],
    [{ Name: 'grossIncome' }],
  ]);

  const updateConfig = async pref => {
    const payload = JSON.stringify(pref);
    try {
      await authStore.request.post(`${process.env.REACT_APP_API}/api/config`, {
        dashboardConfig: payload,
      });
    } catch (e) {
      console.log(e);
    }
  };

  const { state, dashboardConfig } = orgStore;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const newRowOpen = Boolean(anchorEl);

  const handleRowOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (state === 'done') {
      setPreferences(dashboardConfig);
    }
  }, [state]);

  const addRow = async rowSize => {
    const newArr = [...preferences];
    // newArr[i][j] = val;

    if (rowSize === 'small') {
      newArr.push(['smEmpty', 'smEmpty', 'smEmpty', 'smEmpty']);
    } else if (rowSize === 'medium') {
      newArr.push(['mdEmpty', 'mdEmpty']);
    } else {
      newArr.push(['lgEmpty']);
    }

    await updateConfig(newArr);
    orgStore.updateDashboardConfig(newArr);
    setPreferences(newArr);
  };

  const removeRowByPos = async pos => {
    const newArr = [...preferences];
    newArr.splice(pos, 1);

    await updateConfig(newArr);
    orgStore.updateDashboardConfig(newArr);
    setPreferences(newArr);
  };

  const handleChange = async (val, i, j) => {
    // console.log(val, i, j);
    const newArr = [...preferences];
    newArr[i][j] = { Name: val };
    await updateConfig(preferences);
    orgStore.updateDashboardConfig(newArr);
    setPreferences(newArr);
  };

  if (state === 'loading') return <Spinner />;

  return (
    <div>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => handleClickOpen()}
      >
        Preferences
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <DialogTitle>Dashboard Preferences</DialogTitle>
        <DialogContent style={{ display: 'flex', flexDirection: 'column' }}>
          <DialogContentText>
            Customize dashboard cards according to your personal preferences.
            Settings are unique to an organization and do not carry over.
          </DialogContentText>
          <Button
            size="small"
            disableRipple
            onClick={handleRowOpen}
            style={{ alignSelf: 'flex-end' }}
          >
            <CirclePlusIcon
              style={{
                marginRight: '4px',
                marginLeft: '-3px',
              }}
            />{' '}
            New Row
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={newRowOpen}
            onClose={() => {
              setAnchorEl(null);
            }}
          >
            <MenuItem onClick={() => addRow('small')}>Quarter row</MenuItem>
            <MenuItem onClick={() => addRow('medium')}>Half row</MenuItem>
            <MenuItem onClick={() => addRow('large')}>Full row</MenuItem>
          </Menu>
          <FormControl>
            <Grid container spacing={1} style={{ flexDirection: 'column' }}>
              {preferences &&
                preferences.map((row, i) => (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginTop: '10px',
                      alignItems: 'center',
                    }}
                    key={i}
                  >
                    <h5 style={{ minWidth: '50px' }}>Row {i + 1}</h5>
                    {row.map((widget, j) => {
                      const fullWidget = getWidgetFromShortName(
                        widget.Name,
                      ) || {
                        size: getSizeFromLength(row.length),
                      };
                      return (
                        <div
                          style={{ margin: '0px 10px', width: '100%' }}
                          key={(i, j)}
                        >
                          <SimpleSelect
                            containerStyle={{ width: '100%' }}
                            label={`Widget ${j + 1}`}
                            handleChange={e =>
                              handleChange(e.target.value, i, j)
                            }
                            value={fullWidget.shortName}
                            name={`${i}${j}`}
                          >
                            {getViableWidgets(fullWidget.size).map(widg => (
                              <MenuItem
                                key={widg.shortName}
                                value={widg.shortName}
                              >
                                {widg.name}
                              </MenuItem>
                            ))}
                          </SimpleSelect>
                        </div>
                      );
                    })}
                    <div>
                      <IconButton
                        size="small"
                        onClick={() => removeRowByPos(i)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </div>
                  </div>
                ))}
            </Grid>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DashboardPref;

// <FormControlLabel
//   style={{ alignItems: 'start' }}
//   labelPlacement="top"
//   label={pref.Name}
//   control={
//     <Switch
//       name="Display"
//       checked={pref.Display}
//       value={pref.Display}
//       onChange={handleChange(index)}
//     />
//   }
// />;
// const [preferences, setPreferences] = useState([
//   {
//     Name: 'Unpaid Vouchers',
//     Display: true,
//   },
//   {
//     Name: 'Gross Income',
//     Display: true,
//   },
//   {
//     Name: 'Sync Status',
//     Display: true,
//   },
//   {
//     Name: 'Top Agents',
//     Display: true,
//   },
//   {
//     Name: 'Reports',
//     Display: true,
//   },
// ]);
